module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Map/Marker#1-bbb6805e63e1eed4e934f1f46fe997ab.svg";